import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolSettingsService } from "../services/adminsettings.service";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { UserService } from "../../../shared/services/user.service";
import { ConfirmationService, LazyLoadEvent } from "primeng/api";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolContactUpdateRequest } from "../services/SchoolContactUpdateRequest";

@Component({
	templateUrl: "./schoolcontactinfo.component.html",
})
export class SchoolContactInfoComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private router: Router,
		private schoolsettingService: SchoolSettingsService,
		private confirmationService: ConfirmationService
	) {}
	report = {
		SchoolID: 0,
	};

	schoolList: any = [];
	SchoolID: any = [];
	Contact: any = {
		SchoolID: "",
		SchoolName: "",
		DistrictID: "",
		SchoolNumber: "",
		Phone: "",
		Street: "",
		City: "",
		State: "",
		Zip: "",
		SchoolTypeID: "",
	};

	subscription: any;
	loading: any = false;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "Select a School",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
				}

				if (this.schoolList.length == 1) {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.SchoolList();
	}

	private SchoolList() {
		this.loading = true;

		if (this.report.SchoolID == 0) {
			this.Contact.SchoolID = "";
			this.Contact.SchoolName = "";
			this.Contact.DistrictID = "";
			this.Contact.SchoolNumber = "";
			this.Contact.Phone = "";
			this.Contact.Street = "";
			this.Contact.City = "";
			this.Contact.State = "";
			this.Contact.Zip = "";
			this.Contact.SchoolTypeI = "";

			this.loading = false;

			return;
		}

		var result = this.schoolsettingService.SchoolList(this.report.SchoolID);
		result.subscribe(
			(response: any) => {
				this.Contact = response;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	SchoolUpdate() {
		let parms: SchoolContactUpdateRequest = {
			SchoolID: this.Contact.SchoolID,
			SchoolName: this.Contact.SchoolName,
			DistrictID: this.Contact.DistrictID,
			SchoolNumber: this.Contact.SchoolNumber,
			Phone: this.Contact.Phone,
			Street: this.Contact.Street,
			City: this.Contact.City,
			State: this.Contact.State,
			Zip: this.Contact.Zip,
			// this.Contact.SchoolTypeID
		};

		var result = this.schoolsettingService.SchoolContactUpdate(parms);
		result.subscribe((response) => {
			if (response) {
				//Success Dialog
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "School Contact Info was updated successfully",
					header: "Success",
					icon: "fa",
					accept: () => {},
				});
			} else {
				//Fail Dialog
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Could Not update the School Contact Info",
					header: "ERROR",
					icon: "fa",
					accept: () => {},
				});
			}
		});
	}
}
